import { DrawStage, publicClient } from "@toorak/tc-common-fe-sdk";
import Cookies from "js-cookie";
import { getConfig } from "../../config/config";
import {
  showLoader,
  hideLoader
} from "../loaderAndException/loaderAndException.action";
import { getCookie } from "../../utils/cookies";
import { downloadExportedTape } from "../../create-loan/create-loan.action";

import { sanitizeCurrency } from "../../utils/formatChecks";
import { getRoles, isOrigUser } from "../../utils/AccessManagement";
import { DrawInternalNotesInterface, DrawObj } from "./drawRequest.interface";
import {
  getUsername,
  sanitizeStringToNum
} from "../../assetManagement/AssetManagement.utils";
import { apiUrlHost } from "../servicerOnboarding/servicerOnboarding.action";
import {
  getDocsByDrawId,
  initBankObj,
  setAdditionalLoanEconomicsData,
  setFieldsHistory,
  updateAssigneeList,
  updateBankList,
  updateBudgetReviewCommentsRedux,
  updateBudgetReconcileRedux,
  updateBudgetReconcileReportsRedux,
  updateDrawAvalBank,
  updateDrawCount,
  updateDrawData,
  updateDrawDiscussions,
  updateDrawHistory,
  updateDrawInternalNotes,
  updateDrawObj,
  updateDrawPropOptions,
  updateDrawSelectedProp,
  updateDrawStageHistory,
  updateElasticSearchBody,
  updateFinalApproval,
  updateBudgetReconcileCommentsRedux,
  updateInspectionReviewRedux,
  updateLoanIds,
  updateProvisionData,
  updateReconcileItemHistoryRedux,
  updateSelectedBankObj
} from "./drawRequest.reducer";
import { getChatMeta } from "../commentsSection/comment.action";
import { getPartyId } from "../WaiverRequest/WaiverRequest.action";
import { postLineComment } from "../budgetReview/budgetReview.action";
import { createCommentThread1 } from "../Discussions/Discussions.action";
import { sortArrayByUpdatedOn } from "../../budget-review/BudgetReview.utils";
import { taskNames } from "../tasks/Tasks.action";
import { getTaskDetails } from "../../network/apiService";
import { updatePurchaseFlags } from "../purchasedLoansDocReview/purchasedLoansDocReview.action";
import { calculateNetAmount } from "../../assetManagement/DrawRequest/DrawDataLeftPanel/DrawAmountDetails";

/** Choose default bank:
 * 1) If any items have drawNumber, pick highest drawNumber
 * 2) Else if any items have requestedDate, pick latest requestedDate
 * 3) Else if any items have bankDetailId, pick highest bankDetailId
 * 4) Else fall back to first item
 */
function pickDefaultBank(list: any[]): any {
  if (!list || list.length === 0) return undefined;

  const hasNonEmpty = (val: any) =>
    val !== null && val !== undefined && String(val).trim() !== "";

  const toNumeric = (val: any): number => {
    if (!hasNonEmpty(val)) return Number.NaN;
    const n = Number(String(val).replace(/[^0-9.-]/g, ""));
    return Number.isNaN(n) ? Number.NaN : n;
  };

  const withDrawNumber = list.filter((b: any) => !Number.isNaN(toNumeric(b?.drawNumber)));
  if (withDrawNumber.length > 0) {
    return withDrawNumber.reduce((best: any, b: any) => {
      const bVal = toNumeric(b?.drawNumber);
      const bestVal = toNumeric(best?.drawNumber);
      return Number.isNaN(bestVal) || bVal > bestVal ? b : best;
    });
  }

  const withRequestedDate = list.filter(
    (b: any) =>
      hasNonEmpty(b?.requestedDate) &&
      !Number.isNaN(new Date(b.requestedDate).getTime())
  );
  if (withRequestedDate.length > 0) {
    return withRequestedDate.reduce((best: any, b: any) => {
      const bVal = new Date(b.requestedDate).getTime();
      const bestVal = new Date(best?.requestedDate).getTime();
      return Number.isNaN(bestVal) || bVal > bestVal ? b : best;
    });
  }

  const withBankDetailId = list.filter((b: any) => hasNonEmpty(b?.bankDetailId));
  if (withBankDetailId.length > 0) {
    return withBankDetailId.reduce((best: any, b: any) => {
      const bVal = Number(b.bankDetailId);
      const bestVal = Number(best?.bankDetailId);
      return !Number.isNaN(bVal) && (Number.isNaN(bestVal) || bVal > bestVal) ? b : best;
    });
  }

  return list[0];
}

export function getDrawRequestData(
  filterObj: any,
  isOriginator: boolean,
  page: number,
  size: number,
  cb?: any
): any {
  return async (dispatch: any) => {
    try {
      filterObj.offsetTime = new Date().getTimezoneOffset();
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/all?owner=${owner}&isOriginator=${isOriginator}&page=${page}&size=${size}&isTestParty=${getCookie(
        "isTestParty"
      )}`;
      const response = (await publicClient.post(url, filterObj)).data;
      // let formattedData = [...response.data];
      if (cb) {
        cb(response.totalDraws);
      } else {
        const UpdatedResponse = response.draws.map((item: any) => {
          if (!item.progress) {
            item.progress = " ";
          }
          return item;
        });

        dispatch(
          updateDrawData(UpdatedResponse.length > 0 ? UpdatedResponse : [])
        );
        dispatch(
          updateDrawCount(UpdatedResponse.length > 0 ? response.totalDraws : 0)
        );
      }

      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export function getAllAssignee(): any {
  return async (dispatch: any) => {
    try {
      const url = `${apiUrlHost}/drawservice/assetmanagement/ammembers`;
      let response = (await publicClient.get(url)).data;
      response = response.filter(
        (item: any) => item.amMemberName.trim() !== ""
      );
      dispatch(updateAssigneeList(response?.length > 0 ? response : []));
    } catch (err) {
      console.error(err);
    }
  };
}

export async function updateAssigneTo(drawIds: any, value: any) {
  try {
    const owner = getCookie("org_id");
    const url = `${apiUrlHost}/drawservice/assetmanagement/assign?owner=${owner}`;
    const reqBody = {
      drawList: drawIds,
      assignedTo: value
    };
    const response = await publicClient.patch(url, reqBody);
    if (response.status === 200) {
      return Promise.resolve();
    }
  } catch (err) {
    console.error(err);
    return Promise.reject();
  }
  // };
}

export function bulkUpdateStatus(
  status: DrawStage,
  drawId: any,
  role: string,
  comment: string
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/update/stage?isOriginator=false&owner=${owner}`;
      const reqBody = {
        stage: status,
        comment,
        role,
        username: getUsername(),
        drawId: drawId.join().split(",")
      };
      const response = await (await publicClient.put(url, reqBody)).data;
      if (response.status === 200) {
        return Promise.resolve();
      }
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
    }
  };
}

export async function updateDrawDocTagStatus(
  drawId: any,
  dispatch: any,
  statuses: any
) {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/tagstatus`;
    const reqBody: any = {};
    statuses?.forEach((status: any) => {
      if (status.value !== undefined) {
        reqBody[status.key] = status.value;
        reqBody.inspectionReviewApprovedUser =
          status?.inspectionReviewApprovedUser;
        reqBody.inspectionReviewApprovedOn = status?.inspectionReviewApprovedOn;
        reqBody.amountMismatchFlag = status?.amountMismatchFlag;
      }
    });
    const response = await publicClient.patch(url, reqBody);
    dispatch(hideLoader());
  } catch (err) {
    dispatch(hideLoader());
  }
}

export function getElasticSearchQuery(val: string) {
  return {
    query: {
      bool: {
        should: [
          {
            multi_match: {
              query: val,
              fields: [
                "loan.loanDetailId.toorakLoanId",
                "loan.loanInfo.primaryLoanId"
              ],
              analyzer: "standard",
              type: "phrase_prefix"
            }
          }
        ]
      }
    },
    source: ["*"],
    trackTotalHits: true,
    sort: [
      {
        fieldPath: "updatedOn",
        order: "DESC"
      }
    ],
    size: 20,
    from: 0
  };
}

export function getProvisionsData(
  filterObj: any,
  isOriginator: boolean,
  page: number,
  size: number
): any {
  return async (dispatch: any) => {
    try {
      filterObj.offsetTime = new Date().getTimezoneOffset();
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/provisions/all?owner=${owner}&isOriginator=${isOriginator}&page=${page}&size=${size}`;
      const response = (await publicClient.post(url, filterObj)).data;
      dispatch(updateProvisionData(response));
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export function addProvision(
  originatorLoanId: string,
  toorakLoanId: string,
  provisionval: string,
  provisionId?: any,
  callback?: any
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/drawservice/assetmanagement/provisions`;

      const reqBody: any = [];
      if (provisionId) {
        const editProvisionObj = {
          primaryLoanId: originatorLoanId,
          provision: provisionval,
          addedBy: getUsername(),
          toorakLoanId,
          provisionId
        };
        reqBody.push(editProvisionObj);
      } else {
        const addProvisionObj = {
          primaryLoanId: originatorLoanId,
          provision: provisionval,
          addedBy: getUsername(),
          toorakLoanId
        };
        reqBody.push(addProvisionObj);
      }

      await publicClient.post(url, reqBody);
      if (callback) {
        callback(originatorLoanId);
      }
      dispatch(hideLoader());
    } catch (err) {
      console.log("error occured ", err);
      dispatch(hideLoader());
    }
  };
}

export function deleteProvision(
  provisionId: string,
  callBack: any,
  primaryLoanId?: string
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/drawservice/assetmanagement/provisions/${provisionId}`;
      await publicClient.delete(url);
      if (callBack) {
        callBack(primaryLoanId);
      }
      dispatch(hideLoader());
    } catch (err) {
      console.log("error occured ", err);
      dispatch(hideLoader());
    }
  };
}

export function getProvisionHistory(toorakLoanId: string, callback: any): any {
  return async (dispatch: any) => {
    try {
      // dispatch(showLoader());
      if (!toorakLoanId) {
        console.error("error occured ", "No proper toorakLoanId");
        return;
      }
      const url = `${apiUrlHost}/drawservice/assetmanagement/v2/${toorakLoanId}/provisions`;
      const response = await publicClient.get(url);
      if (response && response?.data) {
        callback(response.data, toorakLoanId);
      }
      // dispatch(hideLoader());
    } catch (err) {
      console.error("error occured ", err);
      // dispatch(hideLoader());
    }
  };
}

export function updateProvision(primaryLoanId: string, value: string): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/update/provision?owner=${owner}&isOriginator=false`;
      const reqBody = {
        primaryLoanId,
        provision: value
      };
      await publicClient.put(url, reqBody);
      dispatch(hideLoader());
    } catch (err) {
      console.log("error occured ", err);
      dispatch(hideLoader());
    }
  };
}

export function updateElasticSearchResponse(val: any, callback?: any): any {
  return async (dispatch: any) => {
    try {
      if (val.trim() === "") {
        dispatch(updateElasticSearchBody([]));
        return;
      }
      const url = `${getConfig().apiUrl}/search/v2/${
        getConfig().prefix
      }_loan_aggregate/_search`;
      const reqBody = getElasticSearchQuery(val);
      const response = await publicClient.post(url, reqBody);
      const resArray =
        response?.data?.response?.hits?.hits?.length > 0
          ? response.data.response.hits.hits
          : [];
      dispatch(updateElasticSearchBody(resArray));
      if (callback) {
        callback(resArray);
      }
    } catch (err) {
      console.error(err);
    }
  };
}

export const updateDrawProgressField =
  (drawIds: any, progress: string, callBack?: any): any =>
  async (dispatch: any) => {
    if (progress === "Select") return;
    dispatch(showLoader());
    try {
      const owner = getCookie("org_id");
      const originatorName = getCookie("organizationName");
      const personId = getCookie("person_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/update/progress?owner=${owner}&isOriginator=false&originatorName=${originatorName}&personId=${personId}`;
      const reqBody = {
        progress,
        drawIds
      };
      const response = (await publicClient.put(url, reqBody)).data;
      if (response) {
        callBack && callBack();
        dispatch(hideLoader());
      }
    } catch (e) {
      console.log(e);
      dispatch(hideLoader());
    }
  };

let loansRequestInFlight = false;

export function getAvailableLoanIds(isOriginator: boolean): any {
  return async (dispatch: any, getState: any) => {
    if (loansRequestInFlight) return;
    const existingIds = getState?.()?.drawRequestStore?.loanIds;
    if (existingIds?.length) return;
    loansRequestInFlight = true;
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const isTestParty = getCookie("isTestParty") === "true";
      const url = `${apiUrlHost}/drawservice/assetmanagement/v2/draws/loans?owner=${owner}&isOriginator=${isOriginator}&isTestParty=${isTestParty}`;
      const response = await publicClient.get(url);
      dispatch(updateLoanIds(response.data));
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    } finally {
      loansRequestInFlight = false;
    }
  };
}

export function getDrawDetailsbyLoanId(
  isOriginator: boolean,
  toorakLoanId: string,
  drawId: string,
  setSnackBarMsg: any,
  setOpenSnackBar: any,
  isChanged = true,
  drawAmountDetails: any = {},
  drawObj?: any
): any {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      // Store original loanId for comparison (before URL encoding)
      const originalLoanId = toorakLoanId;
      const isTestParty = getCookie("isTestParty") === "true";
      const url = `${apiUrlHost}/drawservice/assetmanagement/v2/draws/loans/${toorakLoanId}/loan-details?owner=${owner}&isOriginator=${isOriginator}&drawId=${drawId}&isTestParty=${isTestParty}`;
      const response = (await publicClient.get(url)).data;
      if (response?.message) {
        setOpenSnackBar(true);
        setSnackBarMsg({
          messageType: "error",
          message: response.message
        });
      }
      // Get current state once for reuse
      const currentState = getState();
      const drawDetails = currentState?.drawRequestStore?.drawDetails;
      const stage = drawDetails?.stage || response?.stage;
      const primaryLoanId = drawDetails?.primaryLoanId || response?.primaryLoanId;
      
      // Normalize loanId for comparison (handle # encoding)
      const normalizedLoanId = originalLoanId.endsWith("#") 
        ? originalLoanId.slice(0, -1) 
        : originalLoanId;
      const normalizedPrimaryLoanId = primaryLoanId?.endsWith("#")
        ? primaryLoanId.slice(0, -1)
        : primaryLoanId;
      
      // Only preserve if: stage is Draft AND primaryLoanId from first endpoint matches loanId parameter
      const shouldPreserve = stage === DrawStage.draft && 
        normalizedPrimaryLoanId === normalizedLoanId;
      // Snapshot first-load bank now; state is mutated by our dispatches so we must not read it later.
      const firstLoadBankSnapshot = shouldPreserve && currentState?.drawRequestStore?.selectedBankDetails
        ? { ...currentState.drawRequestStore.selectedBankDetails }
        : null;

      // Capture full bank list for Account List dropdown before mergeExcelRowIntoDrawResponse overwrites response.bankDetails with a single Excel bank.
      const fullBankListFromApi = Array.isArray(response.bankDetails)
        ? [...response.bankDetails]
        : response.bankDetails && typeof response.bankDetails === "object"
          ? [response.bankDetails]
          : [];

      if (isChanged) {
        // Only overwrite with passed drawAmountDetails when it has meaningful data (not default {}).
        // Otherwise a later getDrawDetailsbyLoanId call (e.g. from options effect) would overwrite
        // Excel-merged amount with empty object.
        const hasPassedAmount =
          drawAmountDetails &&
          typeof drawAmountDetails === "object" &&
          Object.keys(drawAmountDetails).length > 0;
        if (hasPassedAmount) {
          response.drawAmountDetails = drawAmountDetails;
        } else if (!isDrawIdMarkedAsSaved(drawId)) {
          const excelRow = getExcelRowForDraw(drawId, getState);
          if (excelRow) mergeExcelRowIntoDrawResponse(response, excelRow, drawId);
          // If response still has no/zero amount or bank (e.g. Excel row used different keys),
          // preserve from current Redux state so the second call doesn't overwrite the first load.
          if (shouldPreserve) {
            const existing = currentState?.drawRequestStore?.drawDetails;
            const existingAmount = existing?.drawAmountDetails;
            const stillEmptyAmount =
              !response.drawAmountDetails?.drawAmount ||
              String(response.drawAmountDetails.drawAmount).trim() === "" ||
              Number(response.drawAmountDetails.drawAmount) === 0;
            if (stillEmptyAmount && existingAmount?.drawAmount != null && String(existingAmount.drawAmount).trim() !== "" && Number(existingAmount.drawAmount) !== 0) {
              response.drawAmountDetails = { ...(response.drawAmountDetails || {}), ...existingAmount };
              if (response.stage === DrawStage.draft && response.drawAmountDetails) {
                response.drawAmountDetails.netFundsToBorrower = calculateNetAmount(response.drawAmountDetails);
              }
            }
          }
        }
        // Use API response values for loanStatus, gracePeriod, and payOffRequestDate
        // Only preserve from drawObj if API response doesn't have them and we're in draft mode
        if (drawObj && shouldPreserve) {
          // Preserve existing values only if API response doesn't have them
          if (!response.gracePeriod && drawObj.gracePeriod) {
            response.gracePeriod = drawObj.gracePeriod;
          }
          if (!response.payOffRequestDate && drawObj.payOffRequestDate) {
            response.payOffRequestDate = drawObj.payOffRequestDate;
          }
          if (!response.loanStatus && drawObj.loanStatus) {
            response.loanStatus = drawObj.loanStatus;
          }
        }
        // Preserve existing property selection when v2 response has none (e.g. first load after auto-fill)
        const existingProp = currentState?.drawRequestStore?.drawDetails?.propertyDetails;
        if (existingProp?.length && !response.propertyDetails?.length) {
          response.propertyDetails = existingProp;
        }
        // Don't overwrite draw amount/bank from draw API (or Excel-merged state) with loan-details response when it has empty amount/bank.
        // Preserve for both saved and unsaved draws so Excel-merged data is not lost when loan-details runs after getDrawDetailsByDrawId.
        const latestState = getState?.() ?? currentState;
        const existingDraw = latestState?.drawRequestStore?.drawDetails;
        const sameDraw = existingDraw && String(existingDraw.drawId ?? existingDraw.id) === String(drawId);
        const existingHasAmount =
          existingDraw?.drawAmountDetails?.drawAmount != null &&
          String(existingDraw.drawAmountDetails.drawAmount).trim() !== "" &&
          Number(existingDraw.drawAmountDetails.drawAmount) !== 0;
        const responseHasEmptyAmount =
          !response.drawAmountDetails?.drawAmount ||
          String(response.drawAmountDetails.drawAmount).trim() === "" ||
          Number(response.drawAmountDetails.drawAmount) === 0;
        const existingBank = latestState?.drawRequestStore?.selectedBankDetails;
        const existingHasBank =
          existingBank &&
          ((existingBank.accountNumber != null && existingBank.accountNumber !== "" && existingBank.accountNumber !== 0) ||
            (existingBank.routing != null && String(existingBank.routing).trim() !== ""));
        const responseHasEmptyBank = !response.bankDetails ||
          (Array.isArray(response.bankDetails)
            ? response.bankDetails.length === 0 || !(response.bankDetails[0]?.accountNumber ?? response.bankDetails[0]?.routing)
            : !(response.bankDetails?.accountNumber ?? response.bankDetails?.routing));
        if (sameDraw && ((existingHasAmount && responseHasEmptyAmount) || (existingHasBank && responseHasEmptyBank))) {
          if (existingHasAmount && responseHasEmptyAmount && existingDraw.drawAmountDetails) {
            response.drawAmountDetails = { ...(response.drawAmountDetails || {}), ...existingDraw.drawAmountDetails };
            if (response.stage === DrawStage.draft && response.drawAmountDetails) {
              response.drawAmountDetails.netFundsToBorrower = calculateNetAmount(response.drawAmountDetails);
            }
          }
          if (existingHasBank && responseHasEmptyBank && existingBank) {
            response.bankDetails = existingBank;
          }
        }
        // If API response has these values, use them (don't overwrite with drawObj)
        // The API response values will be used by default in transformDrawObj
        response.drawId = response.drawId ?? drawId;
        dispatch(updateDrawObj(response));
        dispatch(updateDrawSelectedProp(response.propertyDetails ?? []));
        
        // Handle bankDetails: prefer existing saved selection (from draw API) over first item in list, so saved routing/account is not overwritten.
        let selectedBankObj = initBankObj;
        const existingBankFromDraw = firstLoadBankSnapshot ?? currentState?.drawRequestStore?.selectedBankDetails;
        const hasExistingBank =
          existingBankFromDraw &&
          existingBankFromDraw !== initBankObj &&
          (
            (existingBankFromDraw.accountNumber != null && existingBankFromDraw.accountNumber !== 0 && existingBankFromDraw.accountNumber !== "") ||
            (existingBankFromDraw.routing != null && String(existingBankFromDraw.routing).trim() !== "")
          );

        if (response.bankDetails) {
          if (Array.isArray(response.bankDetails)) {
            if (response.bankDetails.length > 0) {
              const list = response.bankDetails;
              if (hasExistingBank) {
                const matchById = list.find((b: any) => b.bankDetailId != null && String(b.bankDetailId) === String(existingBankFromDraw.bankDetailId));
                const matchByAccountRouting = list.find(
                  (b: any) =>
                    String(b?.accountNumber ?? "") === String(existingBankFromDraw?.accountNumber ?? "") &&
                    String(b?.routing ?? "") === String(existingBankFromDraw?.routing ?? "")
                );
                if (matchById) selectedBankObj = matchById;
                else if (matchByAccountRouting) selectedBankObj = matchByAccountRouting;
                else selectedBankObj = { ...existingBankFromDraw };
              } else {
                selectedBankObj = pickDefaultBank(list) || list[0];
              }
            }
          } else {
            selectedBankObj = response.bankDetails;
          }
        }
        const isBankObjEmpty = (b: any) =>
          !b || (b === initBankObj) || (
            (b.accountNumber === 0 || b.accountNumber === "" || b.accountNumber == null) &&
            (!b.routing || String(b.routing).trim() === "")
          );

        if (shouldPreserve) {
          const drawAlreadySaved = isDrawIdMarkedAsSaved(drawId);
          const excelRow = drawAlreadySaved ? null : getExcelRowForDraw(drawId, getState);
          const bankFromExcel =
            excelRow?.bankDetails &&
            (Array.isArray(excelRow.bankDetails) ? excelRow.bankDetails[0] : excelRow.bankDetails);
          const hasExcelBank =
            bankFromExcel?.accountNumber ?? bankFromExcel?.routing ?? excelRow?.accountNumber ?? excelRow?.routing;
          if (hasExcelBank && !drawAlreadySaved) {
            const b = bankFromExcel ?? excelRow;
            selectedBankObj = {
              accountNumber: b.accountNumber ?? excelRow?.accountNumber ?? 0,
              routing: b.routing ?? excelRow?.routing ?? "",
              bankName: b.bankName ?? excelRow?.bankName ?? "",
              accountName: b.accountName ?? excelRow?.accountName ?? "",
              bankDetailId: b.bankDetailId ?? 0
            };
          } else if (hasExistingBank) {
            selectedBankObj = existingBankFromDraw;
          } else if (isBankObjEmpty(selectedBankObj) && drawObj?.bankDetails) {
            if (Array.isArray(drawObj.bankDetails)) {
              selectedBankObj = drawObj.bankDetails.length > 0 ? drawObj.bankDetails[0] : initBankObj;
            } else if (typeof drawObj.bankDetails === "object") {
              selectedBankObj = drawObj.bankDetails;
            }
          }
        } else if (isBankObjEmpty(selectedBankObj) && hasExistingBank) {
          selectedBankObj = existingBankFromDraw;
        }
        // After refresh, always prefer stored saved bank for this draw so loan-details response doesn't overwrite it (e.g. with list[0])
        if (isDrawIdMarkedAsSaved(drawId)) {
          try {
            const stored = sessionStorage.getItem(`${DRAW_SAVED_BANK_KEY_PREFIX}${drawId}`);
            if (stored) {
              const savedBank = JSON.parse(stored);
              const hasSaved = (savedBank.accountNumber != null && savedBank.accountNumber !== "" && savedBank.accountNumber !== 0) ||
                (savedBank.routing != null && String(savedBank.routing).trim() !== "");
              if (hasSaved) {
                const list = Array.isArray(response.bankDetails) ? response.bankDetails : response.bankDetails ? [response.bankDetails] : [];
                const match = list.find(
                  (b: any) =>
                    String(b?.accountNumber ?? "") === String(savedBank?.accountNumber ?? "") &&
                    String(b?.routing ?? "") === String(savedBank?.routing ?? "")
                );
                selectedBankObj = match ?? savedBank;
              }
            }
          } catch (_) {}
        }
        dispatch(updateSelectedBankObj(selectedBankObj));
      }
      
      // Use full bank list from API for Account List dropdown (response.bankDetails may have been overwritten by mergeExcelRowIntoDrawResponse with a single Excel bank).
      let listForDropdown = fullBankListFromApi.length > 0
        ? fullBankListFromApi
        : [];
      if (listForDropdown.length === 0 && shouldPreserve) {
        const existingAvailableBanks = currentState?.drawRequestStore?.availableBankAccountDetails;
        if (existingAvailableBanks && Array.isArray(existingAvailableBanks) && existingAvailableBanks.length > 0) {
          listForDropdown = existingAvailableBanks;
        }
      }
      dispatch(updateDrawAvalBank({
        ...response,
        bankDetails: listForDropdown,
        bankList: response.bankList,
      }));
      dispatch(updateDrawPropOptions(response.propertyDetails));
      if (response?.propertyDetails?.length === 1) {
        dispatch(updateDrawSelectedProp(response.propertyDetails));
      }

      // Re-apply Excel amount and bank only when API had no saved data (first load after Excel create). After user saves and reloads, prefer API.
      if (shouldPreserve) {
        const stateAfter = getState();
        const currentDraw = stateAfter?.drawRequestStore?.drawDetails;
        const currentBank = stateAfter?.drawRequestStore?.selectedBankDetails;
        const hasSavedAmount =
          currentDraw?.drawAmountDetails?.drawAmount != null &&
          String(currentDraw.drawAmountDetails.drawAmount).trim() !== "" &&
          Number(currentDraw.drawAmountDetails.drawAmount) !== 0;
        const hasSavedBank =
          currentBank &&
          ((currentBank.accountNumber != null && currentBank.accountNumber !== "" && currentBank.accountNumber !== 0) ||
            (currentBank?.routing && String(currentBank.routing).trim() !== ""));
        if (hasSavedAmount && hasSavedBank) return; // API has saved data; don't overwrite with Excel.

        const excelRow = getExcelRowForDraw(drawId, getState);
        if (excelRow) {
          if (!hasSavedAmount) {
            const excelAmount =
              excelRow.drawAmountDetails?.drawAmount ??
              excelRow.drawAmount ??
              excelRow.requestedAmount ??
              excelRow.amount;
            if (excelAmount != null && String(excelAmount).trim() !== "" && Number(excelAmount) !== 0) {
              const src = excelRow.drawAmountDetails ?? excelRow;
              const mergedAmount = {
                ...(currentDraw?.drawAmountDetails ?? {}),
                drawAmount:
                  src.drawAmount ??
                  excelRow.drawAmount ??
                  excelRow.requestedAmount ??
                  excelRow.amount,
                wireFee: src.wireFee ?? currentDraw?.drawAmountDetails?.wireFee ?? "0.00",
                costOfInspection: src.costOfInspection ?? currentDraw?.drawAmountDetails?.costOfInspection ?? "0.00",
                titleServiceFee: src.titleServiceFee ?? currentDraw?.drawAmountDetails?.titleServiceFee ?? "0.00",
                wireReturnFee: src.wireReturnFee ?? currentDraw?.drawAmountDetails?.wireReturnFee ?? "0.00"
              };
              mergedAmount.netFundsToBorrower = calculateNetAmount(mergedAmount);
              dispatch(updateDrawObj({ ...currentDraw, drawAmountDetails: mergedAmount }));
            }
          }
          if (!hasSavedBank) {
            let bankToApply: any = null;
            try {
              const stored = sessionStorage.getItem(`drawExcelBank_${drawId}`);
              if (stored) bankToApply = JSON.parse(stored);
            } catch (_) {}
            if (!bankToApply) {
              const bankFromExcel = excelRow.bankDetails && (Array.isArray(excelRow.bankDetails) ? excelRow.bankDetails[0] : excelRow.bankDetails);
              const hasExcelBank = bankFromExcel?.accountNumber ?? bankFromExcel?.routing ?? excelRow?.accountNumber ?? excelRow?.routing;
              if (hasExcelBank) {
                const b = bankFromExcel ?? excelRow;
                bankToApply = {
                  accountNumber: b.accountNumber ?? excelRow?.accountNumber ?? 0,
                  routing: b.routing ?? excelRow?.routing ?? "",
                  bankName: b.bankName ?? excelRow?.bankName ?? "",
                  accountName: b.accountName ?? excelRow?.accountName ?? "",
                  bankDetailId: b.bankDetailId ?? 0
                };
              } else {
                bankToApply = firstLoadBankSnapshot;
              }
            }
            const hasBank = bankToApply && bankToApply !== initBankObj &&
              ((bankToApply.accountNumber != null && bankToApply.accountNumber !== 0 && bankToApply.accountNumber !== "") ||
                (bankToApply.routing && String(bankToApply.routing).trim() !== ""));
            if (hasBank) {
              dispatch(updateSelectedBankObj({
                accountNumber: bankToApply.accountNumber ?? 0,
                routing: bankToApply.routing ?? "",
                bankName: bankToApply.bankName ?? "",
                accountName: bankToApply.accountName ?? "",
                bankDetailId: bankToApply.bankDetailId ?? 0
              }));
            }
          }
        }
      }

      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export function getDocsListbyDrawId(
  isOriginator: boolean,
  drawId: string
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/documents/getAll?owner=${owner}&isOriginator=${isOriginator}`;
      const response = (await publicClient.get(url)).data;
      let docList = response?.DocumentsList;
      if (docList && docList?.length > 0) {
        let isPrimaryAPITriggered = false;
        let primaryDocId: any;
        let inspectionDocPrimary = false;
        response.DocumentsList.forEach((item: any) => {
          const tagsArr = item?.tags;
          const tagCode = tagsArr?.[0]?.tag?.code;
          const confidenceScore = tagsArr?.[0]?.confidence_score;
          if (
            tagCode === "DDDC" &&
            item.isPurchasePrimary === false &&
            item?.assets?.length > 0 &&
            confidenceScore > 0.9
          ) {
            isPrimaryAPITriggered = true;
            primaryDocId = item.documentId;
          } else if (tagCode === "DDDC" && item.isPurchasePrimary === true) {
            inspectionDocPrimary = true;
          }
        });
        if (isPrimaryAPITriggered && !inspectionDocPrimary) {
          try {
            const payload = {
              id: primaryDocId,
              isPurchasePrimary: true
            };
            updatePurchaseFlags([payload]);
            docList = docList?.map((item: any) => {
              if (item.documentId === primaryDocId) {
                item.isPurchasePrimary = true;
              }
              return item;
            });
          } catch (err) {
            console.error(err);
          }
        }
      }
      dispatch(getDocsByDrawId(docList));
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export async function isBudgetReviewRedo(
  loanId: string,
  selectedPropId: string,
  dispatch: any
): Promise<any> {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/ocr/budget-loan/${loanId}`;
    const response: any = (await publicClient.get(url)).data;

    const propData = response.budgetDocumentInfoList?.filter(
      (item: any) => item.propertyId == selectedPropId
    )[0];
    dispatch(hideLoader());
    return Promise.resolve(propData.isRedoInProcess);
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
    return Promise.reject(err);
  }
}

export async function getInspectionReviewDetails(
  loanId: string,
  drawId: string,
  dispatch: any
) {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/loan/${loanId}/inspectionreview/draw/${drawId}`;
    const response = (await publicClient.get(url)).data;
    dispatch(updateInspectionReviewRedux(response));
    dispatch(hideLoader());
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
  }
}

export async function getAllBudgetInspectionComments(
  chatIds: any,
  lineItemsList: any,
  dispatch: any
) {
  try {
    dispatch(showLoader());
    const payloadChatIds = [
      ...chatIds.budgetReconcile,
      ...chatIds.budgetReview
    ];
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/budgetreconcile/comments?limit=200&offset=0`;
    const reqBody = {
      chatIds: payloadChatIds
    };
    const response: any = (await publicClient.post(url, reqBody)).data || [];
    const budgetReviewComments: any = [];
    const budgetReconcileComments: any = [];
    response?.forEach((item: any) => {
      const { chatLines: chatRes, customers } = item;
      const userMap = new Map();
      customers?.forEach((cus: any) => {
        userMap.set(cus.partyId, cus);
      });
      chatRes?.forEach((key: any) => {
        const userObj = userMap.get(key.partyId);
        let userName = "";
        if (userObj?.firstName) {
          userName += `${userObj?.firstName} `;
        }
        if (userObj?.middleName) {
          userName += `${userObj?.middleName} `;
        }
        if (userObj?.lastName) {
          userName += userObj?.lastName;
        }
        key.createdBy = userName;
        const lineItem = lineItemsList.filter(
          (line: any) =>
            key.chatId === line.reconcileCommentDiscussionId ||
            key.chatId === line.commentDiscussionId
        )[0];
        key.lineItem = lineItem.item;
        if (chatIds.budgetReconcile?.includes(key.chatId)) {
          budgetReconcileComments.push(key);
        }
        if (chatIds.budgetReview?.includes(key.chatId)) {
          budgetReviewComments.push(key);
        }
      });
    });
    budgetReviewComments?.forEach((item: any) => {
      item.type = "budgetReview";
    });
    budgetReconcileComments?.forEach((item: any) => {
      item.type = "budgetReconcile";
    });
    dispatch(updateBudgetReviewCommentsRedux(budgetReviewComments));
    dispatch(updateBudgetReconcileCommentsRedux(budgetReconcileComments));
    dispatch(hideLoader());
    return response;
  } catch (err) {
    dispatch(hideLoader());
    throw err;
  }
}

export async function getBudgetReconcileDetails(
  drawId: any,
  dispatch: any,
  isShowLoader = true
) {
  try {
    if (isShowLoader) {
      dispatch(showLoader());
    }
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/${drawId}/budgetreconcile`;
    let response = (await publicClient.get(url)).data;
    response = response.sort((a: any, b: any) => {
      const aOrder = a.budgetLineItem?.inspectionItemOrder;
      const bOrder = b.budgetLineItem?.inspectionItemOrder;
      if (aOrder === null && bOrder === null) {
        return a.budgetLineItem?.item.localeCompare(b.budgetLineItem?.item);
      }
      if (aOrder === null) {
        return 1;
      }
      if (bOrder === null) {
        return -1;
      }
      return aOrder - bOrder;
    });
    dispatch(updateBudgetReconcileRedux(response));
    if (isShowLoader) {
      dispatch(hideLoader());
    }
    return response;
  } catch (err) {
    if (isShowLoader) {
      dispatch(hideLoader());
    }
    console.error(err);
    return [];
  }
}

export async function redoReconcileHandler(drawId: any, dispatch: any) {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/budgetreconcile/redo/inspectionReview`;
    const payload = {
      drawId
    };
    const response = await publicClient.put(url, payload);
    dispatch(hideLoader());
    return response;
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
    return [];
  }
}

export async function getBudgetReconcileReports(
  drawId: any,
  toorakLoanId: any,
  dispatch: any
) {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/aggregate/${toorakLoanId}/reports/${drawId}`;
    const response = (await publicClient.get(url)).data;
    dispatch(updateBudgetReconcileReportsRedux(response));
    dispatch(hideLoader());
    return response;
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
    return {};
  }
}

export async function getReconcileItemHistory(
  reconcileItemsId: any,
  dispatch: any
) {
  try {
    dispatch(showLoader());
    dispatch(
      updateReconcileItemHistoryRedux([
        {
          drawNumber: 2,
          amount: 750,
          completion: `50 ${reconcileItemsId}`,
          createdAt: "25-06-2024"
        },
        {
          drawNumber: 1,
          amount: 760,
          completion: "20",
          createdAt: "24-06-2024"
        }
      ])
    );
    dispatch(hideLoader());
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
  }
}

export async function updateIRPredictionStatus(
  reqBody: any,
  extractionSourceDocumentId: string,
  cb: any
) {
  const url = `${apiUrlHost}/ocr/extraction/${extractionSourceDocumentId}`;
  const resp = (await publicClient.patch(url, reqBody)).data;
  // dispatch(updateInspectionReviewRedux(resp));
  cb && cb(resp);
}

export const getBudgetReconcileCommentsList = async (drawId: string) => {
  const comments: any = (
    await getChatMeta("DRAW", drawId, "CHAT_TOPIC", "INSPECTION_REVIEW")
  ).data;
  return comments;
};

export async function updateBudgetReconcileButtonAction(
  drawId: string,
  payload: any,
  dispatch: any
) {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/budgetreconcile/${drawId}/comments`;
    const response = await publicClient.put(url, payload);
    dispatch(hideLoader());
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
  }
}

export async function updateBudgetApprovedAmount(
  drawId: string,
  payload: any,
  dispatch: any
) {
  try {
    // dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/budgetreconcile/${drawId}/updateApprovedLatestCompletion`;
    const response = await publicClient.patch(url, payload);
    // dispatch(hideLoader());
  } catch (err) {
    // dispatch(hideLoader());
    console.error(err);
  }
}

export async function startReconcileAPI(drawId: string) {
  try {
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/${drawId}/startreconcile`;
    const response = (await publicClient.put(url)).data;
    return Promise.resolve(response);
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export const getIRandBRHistory = async (reqBody: any) => {
  // return async (dispatch: any) => {
  try {
    const url = `${apiUrlHost}/taskservice/tasks/audit/fetch`;
    const response = (await publicClient.post(url, reqBody)).data;
    const sortedInspectionHistory = sortArrayByUpdatedOn(
      response[0]?.budgetReconcile
    );
    let returnObj: any = {
      sortedInspectionHistory,
      sortedBudgetReconcileHistory: []
    };
    if (response[0] && response[0].inspectionReview) {
      const sortedBudgetReconcileHistory = sortArrayByUpdatedOn(
        response[0].inspectionReview
      );
      returnObj = {
        ...returnObj,
        ...{ sortedBudgetReconcileHistory }
      };
      // dispatch(updateBudgetApprovalHistory(sortedBudgetApprovalHistory));
    }

    return returnObj;
    // else {
    //   getTasks(
    //     dispatch,
    //     {
    //       resourceTypes: ["LOAN"],
    //       resourceIds: [loanId],
    //       taskNames: [
    //         taskNames.TAG,
    //         taskNames.SPLIT,
    //         taskNames.REVIEW,
    //         taskNames.RECONCILE,
    //         taskNames.BUDGET_REVIEW,
    //         taskNames.BUDGET_APPROVE
    //       ]
    //     },
    //     false,
    //     true
    //   );
    // }
    // dispatch(updateBudgetStatus(sortedBudgetHistory[0].taskStatus));
    // if (
    //   [
    //     budgetReviewStatusEnum.ReadyForBudgetReview,
    //     budgetReviewStatusEnum.InProgress
    //   ].includes(
    //     sortedBudgetHistory[0].taskStatus as budgetReviewStatusEnum
    //   ) &&
    //   ["UnAssigned", "", null].includes(
    //     sortedBudgetHistory[0].assigneePartyId
    //   )
    // ) {
    //   //assign to self
    //   let newTaskObj = await selfAssigneTask(
    //     sortedBudgetHistory,
    //     response[0]
    //   );
    //   sortedBudgetHistory.unshift(newTaskObj);
    // }
    // dispatch(updateBudgetHistory(sortedBudgetHistory));
  } catch (e) {
    console.error(e);
  }
  // };
};

export const createAndUpdateIRComments = async (
  commentId: string,
  drawId: string,
  commentText: string,
  title: string
) => {
  const { partyId } = getPartyId();
  const payload = {
    partyId,
    lineText: commentText,
    hasDocuments: false
  };
  let commentThreadId;
  try {
    if (commentId) {
      commentThreadId = commentId;
    } else {
      const res: any = await createCommentThread1(
        "DRAW",
        drawId,
        "CHAT_TOPIC",
        "INSPECTION_REVIEW",
        title
      );
      commentThreadId = res.id;
    }
    return await postLineComment(commentThreadId, payload);
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

const taskNameToStatus: any = {
  budgetReconcile: "budgetReconcileStatus",
  inspectionReview: "inspectionReviewStatus"
};

export async function saveReviewAndReconcileStatus(
  drawId: string,
  payload: any,
  dispatch: any,
  operation?: any
) {
  try {
    dispatch(showLoader());
    const payloadData: any[] = [];
    const { partyId } = getPartyId();
    const firstName = Cookies.get("firstName");
    const lastName = Cookies.get("lastName");
    const statusesArr: any = [];
    payload?.forEach((item: any) => {
      const statusPayload: any = {};
      statusPayload.key = taskNameToStatus[item.name];
      statusPayload.value = item.status;
      statusesArr.push({
        ...statusPayload,
        inspectionReviewApprovedUser: getCookie("person_id"),
        inspectionReviewApprovedOn: new Date().toISOString(),
        amountMismatchFlag: item?.amountMismatchFlag
      });
      payloadData.push({
        resourceId: drawId,
        resourceType: "DRAW",
        assignedTasks: [
          {
            taskStatus: item.status,
            assignedBy: `${firstName} ${lastName}`,
            taskName: item.name,
            resourceId: item.resourceId || drawId,
            taskId: operation !== "add" && item.taskId,
            op: operation || "replace",
            updatedBy: partyId,
            comment: item.comment
          }
        ]
      });
    });
    updateDrawDocTagStatus(drawId, dispatch, statusesArr);
    const url = `${apiUrlHost}/taskservice/tasks`;
    const response = (await publicClient.patch(url, payloadData)).data;
    dispatch(hideLoader());
    return Promise.resolve(response);
  } catch (err) {
    dispatch(hideLoader());
    console.error(err);
    return Promise.reject(err);
  }
}

export async function updateInspectionReview(
  drawId: string,
  reqBody: any,
  dispatch: any
) {
  try {
    const url = `${apiUrlHost}/drawservice/assetmanagement/draw/${drawId}/inspectionreview`;
    const response = (await publicClient.patch(url, reqBody)).data;
    dispatch(updateInspectionReviewRedux(reqBody));
    return Promise.resolve(response);
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export const postDrawStageHistory: any =
  (
    drawId: string,
    stage: DrawStage,
    role: string,
    createdBy: string,
    comment = ""
  ) =>
  async (dispatch: any) => {
    dispatch(showLoader());
    try {
      const owner = getCookie("org_id");
      const originatorName = getCookie("organizationName");
      const personId = getCookie("person_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/update/stage?owner=${owner}&isOriginator=false&originatorName=${originatorName}&personId=${personId}`;

      const reqBody = {
        stage,
        comment,
        role,
        username: getUsername(),
        createdBy
      };
      const response = (await publicClient.put(url, reqBody)).data;
      if (response) {
        dispatch(updateDrawStageHistory(response.payload?.drawHistory));
        dispatch(hideLoader());
        return Promise.resolve("success");
      }
    } catch (e) {
      console.error(e);
      dispatch(hideLoader());
      return Promise.reject("fail");
    }
  };

export const updateDrawDetails =
  (
    drawObj: any,
    selectedBankDetails: any,
    drawId: string,
    isOrig: boolean,
    Stage: DrawStage,
    createdBy: string,
    showL = true,
    isInspection?: boolean
  ): any =>
  async (dispatch: any) => {
    if (showL) {
      dispatch(showLoader());
    }
    const {
      toorakLoanId,
      servicerName,
      servicerId,
      propertyDetails,
      prePurchaseDrawAmount,
      originatorId,
      loanType,
      drawType,
      financedBudgetAmount,
      drawNumber,
      drawAmountDetails,
      balanceToFinish,
      borrowerAddress,
      borrowerEntityName,
      primaryLoanId,
      // originalMaturityDate,
      // currentMaturityDate,
      maturityDate,
      nextPaymentDueDate,
      lastUpdatedDate,
      originatorName: origName
    } = drawObj;
    const {
      costOfInspection,
      drawAmount,
      edited,
      netFundsToBorrower,
      titleServiceFee,
      wireFee,
      wireReturnFee,
      latestApprovedAmount,
      comments
    } = drawAmountDetails;

    const owner = getCookie("org_id");
    // const originatorName = getCookie("organizationName");
    const personId = getCookie("person_id");
    let reviewStatus = "";
    // Skip task call during draft autosave; only fetch when submitting (stage change).
    if (Stage !== DrawStage.draft && drawObj.budgetReviewStatus === "") {
      const payload = {
        resourceTypes: ["LOAN"],
        resourceIds: [toorakLoanId],
        taskNames: [taskNames.BUDGET_REVIEW]
      };
      const response: any = await getTaskDetails(payload);
      reviewStatus = response?.data?.[0]?.assignedTasks?.[0]?.taskStatus;
    }
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}?isOriginator=${isOrig}&owner=${owner}&originatorName=${origName}&personId=${personId}&createdBy=${createdBy}`;

    // Recalculate netFundsToBorrower from current values before saving to ensure accuracy
    const recalculatedNetFunds = calculateNetAmount({
      drawAmount,
      wireFee,
      costOfInspection,
      titleServiceFee,
      wireReturnFee
    });

    // Update the Redux store with the recalculated value immediately so UI reflects correct value
    const updatedDrawObj = {
      ...drawObj,
      drawAmountDetails: {
        ...drawAmountDetails,
        netFundsToBorrower: recalculatedNetFunds || netFundsToBorrower
      }
    };
    dispatch(updateDrawObj(updatedDrawObj));

    const drawSaveObject: any = {
      balanceToFinish,
      toorakLoanId,
      propertyDetails,
      primaryLoanId,
      originatorId,
      originatorName: origName,
      loanExcelJson: "",
      maturityDate,
      // originalMaturityDate,
      // currentMaturityDate,
      nextPaymentDueDate,
      // loanState: "in-progress",
      drawAmountDetails: {
        costOfInspection: sanitizeStringToNum(costOfInspection),
        drawAmount: sanitizeStringToNum(drawAmount),
        edited,
        netFundsToBorrower: sanitizeStringToNum(recalculatedNetFunds || netFundsToBorrower),
        titleServiceFee: sanitizeStringToNum(titleServiceFee),
        wireFee: sanitizeStringToNum(wireFee),
        wireReturnFee: sanitizeStringToNum(wireReturnFee),
        latestApprovedAmount: sanitizeStringToNum(latestApprovedAmount),
        comments
      },
      bankDetails: selectedBankDetails || initBankObj,

      servicerId,
      servicerName,
      drawType,
      loanType,
      stage: Stage,
      drawNumber,
      borrowerEntityName,

      borrowerAddress,
      financedBudgetAmount,
      prePurchaseDrawAmount,
      availableFinancedBudgetAmount: null,
      lastUpdatedDate
    };
    if (!latestApprovedAmount || latestApprovedAmount === "0.00") {
      drawSaveObject.drawAmountDetails.latestApprovedAmount =
        sanitizeStringToNum(drawAmount);
    } else {
      drawSaveObject.drawAmountDetails.latestApprovedAmount =
        sanitizeStringToNum(latestApprovedAmount);
    }
    if (drawObj.budgetReviewStatus === "") {
      drawSaveObject.budgetReviewStatus = reviewStatus;
    }
    if (
      Stage !== DrawStage.draft &&
      !(
        drawSaveObject.drawAmountDetails?.netFundsToBorrower &&
        drawSaveObject.drawAmountDetails?.drawAmount
      )
    ) {
      console.error(
        "netFundsToBorrower is missing",
        drawSaveObject.drawAmountDetails,
        netFundsToBorrower
      );
      dispatch(hideLoader());
      return Promise.reject("fail");
    }
    if (!isOrig) {
      drawSaveObject.username = getUsername();
    }
    if (Stage !== DrawStage.draft) {
      drawSaveObject.role = getRoles();
    }
    try {
      const response = (await publicClient.put(url, drawSaveObject)).data;
      if (Stage !== DrawStage.draft) {
        dispatch(
          updateDrawDetailsRedux(response.payload?.drawDetails, isInspection)
        );

        dispatch(formatFieldHistoryRedux(response.payload?.drawHistory));
      } else {
        // Mark this draw as saved so on reload we don't overwrite with Excel data (use both storages so it survives refresh)
        try {
          const key = "drawExcelSavedDrawIds";
          for (const storage of [sessionStorage, localStorage]) {
            const raw = storage.getItem(key);
            const ids: string[] = raw ? JSON.parse(raw) : [];
            if (!ids.includes(String(drawId))) {
              ids.push(String(drawId));
              storage.setItem(key, JSON.stringify(ids));
            }
          }
          // Persist saved bank for this draw so after refresh we restore it (API may return bank list with different order)
          if (selectedBankDetails && (selectedBankDetails.accountNumber != null || selectedBankDetails.routing)) {
            try {
              sessionStorage.setItem(
                `${DRAW_SAVED_BANK_KEY_PREFIX}${drawId}`,
                JSON.stringify(selectedBankDetails)
              );
              sessionStorage.removeItem(`drawExcelBank_${drawId}`);
            } catch (_) {}
          }
        } catch (_) {}
      }
      sessionStorage.removeItem("newDrawCreated");
      dispatch(hideLoader());
      return Promise.resolve("success");
    } catch (e) {
      console.error(e);
      dispatch(hideLoader());
      return Promise.reject("fail");
    }
  };

export function generateDrawId() {
  return new Promise((resolve, reject) => {
    const owner = getCookie("org_id");
    const isOriginator = isOrigUser();
    const username = getUsername();
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/create?owner=${owner}&isOriginator=${isOriginator}&username=${username}`;
    publicClient
      .get(url)
      .then((res: any) => {
        resolve(res);
      })
      .catch(reject);
  });
}

export function deleteDrawById(drawId: string) {
  return new Promise((resolve, reject) => {
    const owner = getCookie("org_id");
    const isOriginator = isOrigUser();
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/delete?owner=${owner}&isOriginator=${isOriginator}`;
    publicClient
      .get(url)
      .then((res: any) => {
        resolve(res);
      })
      .catch(reject);
  });
}

export function exportDrawDetails(
  selectedLoans: any,
  isOrig: boolean,
  createdBy: string
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const tempObj = {
        drawId: selectedLoans
      };
      const owner = getCookie("org_id");
      const personId = getCookie("person_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/download?owner=${owner}&isOriginator=${isOrig}&personId=${personId}&createdBy=${createdBy}`;
      const response = await publicClient.post(url, tempObj);
      if (response) {
        downloadExportedTape(response.data);
        setTimeout(() => {
          dispatch(hideLoader());
        }, 300);
      }
    } catch (err) {
      console.error(err);
      dispatch(hideLoader());
    }
  };
}

export async function reTriggerExtraction(
  toorakLoanId: string,
  drawId: string,
  cb?: any
): Promise<any> {
  try {
    const url = `${apiUrlHost}/ocr/extraction/retrigger/${toorakLoanId}/documents?drawId=${drawId}&tags=DDDC`;
    const response: any[] = (await publicClient.get(url)).data;
    cb && cb(response);
  } catch (err) {
    console.error(err);
  }
}

export function exportDiscussions(
  drawDiscussions: any,
  drawId: any,
  isOrig: boolean,
  tempDiscussion: any[],
  createdBy: string
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const personId = getCookie("person_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/discussions?owner=${owner}&isOriginator=${isOrig}&personId=${personId}&createdBy=${createdBy}`;
      const response = (await publicClient.post(url, drawDiscussions)).data;
      if (response) {
        tempDiscussion[drawId].discussions.unshift(response);
        // console.log(tempDiscussion);
        dispatch(updateDrawDiscussions(tempDiscussion));
        dispatch(hideLoader());
      }
    } catch (err) {
      console.error(err);
      dispatch(hideLoader());
    }
  };
}

export const postInternalNotes =
  (
    noteChat: any,
    drawId: any,
    tempInternalNotes: DrawInternalNotesInterface[]
  ): any =>
  async (dispatch: any) => {
    try {
      dispatch(showLoader());
      // const owner = getCookie("org_id");
      // const personId = getCookie("person_id");
      const reqBody = {
        text: noteChat.text,
        role: noteChat.role
      };
      const url = `${apiUrlHost}/drawservice/assetmanagement/${drawId}/internalnote?userName=${noteChat.userName}`;
      const response = (await publicClient.post(url, reqBody)).data;

      if (response) {
        tempInternalNotes.unshift(response);
        dispatch(updateDrawInternalNotes(tempInternalNotes));
      }
      dispatch(hideLoader());
    } catch (err) {
      console.error(err);
      dispatch(hideLoader());
    }
  };

export const getInternalNotes: any =
  (drawId: string) => async (dispatch: any) => {
    try {
      const url = `${apiUrlHost}/drawservice/assetmanagement/internalnote?drawId=${drawId}`;
      const response = (await publicClient.get(url)).data;
      const responseRev = [...response].reverse();

      if (response) {
        dispatch(updateDrawInternalNotes(responseRev));
      }
    } catch (e) {
      console.error(e);
    }
  };

export const insertDrawDocs =
  (body: any, drawId: string, isOrig: boolean, createdBy: string): any =>
  async (dispatch: any) => {
    const owner = getCookie("org_id");
    const personId = getCookie("person_id");
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/documents?owner=${owner}&isOriginator=${isOrig}&personId=${personId}&createdBy=${createdBy}`;
    try {
      const response = await publicClient.post(url, body);
      return Promise.resolve(response);
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
      // upload is not success
    }
  };

const formatFieldHistoryRedux =
  (resp: any, isStage = false) =>
  async (dispatch: any) => {
    let newds = {};
    Object.keys(resp).forEach((section: any) => {
      if (
        ["dramAmountFieldEditHistory", "bankDetailsFieldEditHistory"].includes(
          section
        )
      ) {
        resp[section].forEach((item: any) => {
          const fieldName = item.key;
          let fields =
            item.fields.length > 3 ? item.fields.slice(0, 3) : item.fields;
          fields.forEach((field: any) => {
            if (section === "dramAmountFieldEditHistory") {
              field.preValue = sanitizeCurrency(field.preValue);
              field.value = sanitizeCurrency(field.value);
            }
          });
          fields = fields.filter(
            (field: any) => field?.preValue !== "" && field?.preValue !== "0"
          );
          const foo = { [fieldName]: fields };
          newds = { ...newds, ...foo };
        });
      }
    });
    dispatch(setFieldsHistory(newds));
    if (isStage) {
      dispatch(updateDrawStageHistory(resp.stageHistory));
    }
  };

export const getFieldHistory =
  (drawId: string, isOrig: boolean): any =>
  async (dispatch: any) => {
    const owner = getCookie("org_id");

    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/history/all?owner=${owner}&isOriginator=${isOrig}`;
    try {
      const resp = (await publicClient.get(url)).data;
      // do mapping here, if required
      // let newds = {};
      dispatch(formatFieldHistoryRedux(resp, true));
    } catch (e) {
      console.error(e);
    }

    // .then((res: any) => resolve(res))
    // .catch(reject);
  };

export const downloadDrawDocs = (
  docIds: string[],
  drawId: string,
  isOrig: boolean,
  createdBy: string
): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!docIds.length) return reject("No DocIds provided");
    const owner = getCookie("org_id");
    const personId = getCookie("person_id");
    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/documents/download?owner=${owner}&isOriginator=${isOrig}&personId=${personId}&createdBy=${createdBy}`;

    const body = {
      docId: docIds
    };

    publicClient
      .post(url, body)
      .then((res: any) => resolve(res))
      .catch(reject);
  });

export const deleteDrawDocs =
  (
    docIds: string[],
    drawId: string,
    isOrig: boolean,
    dontCallGetDocs?: boolean
  ): any =>
  async (dispatch: any) => {
    dispatch(showLoader());
    const owner = getCookie("org_id");

    const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/document?owner=${owner}&isOriginator=${isOrig}`;

    try {
      const response = await publicClient.delete(url, {
        data: { docId: docIds }
      });
      !dontCallGetDocs &&
        dispatch(getDocsByDrawId(response.data.payload?.drawDocuments));
      dispatch(hideLoader());
      return Promise.resolve(response);
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
      // upload is not success
    }
  };

const DRAW_EXCEL_SAVED_IDS_KEY = "drawExcelSavedDrawIds";
const DRAW_SAVED_BANK_KEY_PREFIX = "drawSavedBank_";

function isDrawIdMarkedAsSaved(drawId: string): boolean {
  try {
    for (const storage of [sessionStorage, localStorage]) {
      const raw = storage.getItem(DRAW_EXCEL_SAVED_IDS_KEY);
      const ids: string[] = raw ? JSON.parse(raw) : [];
      if (ids.includes(String(drawId))) return true;
    }
  } catch (_) {}
  return false;
}

function getExcelRowForDraw(
  drawId: string,
  getState: any
): any {
  if (isDrawIdMarkedAsSaved(drawId)) return null;
  try {
    const savedRaw = sessionStorage.getItem(DRAW_EXCEL_SAVED_IDS_KEY);
    const savedIds: string[] = savedRaw ? JSON.parse(savedRaw) : [];
    if (savedIds.includes(String(drawId))) return null;
    const localRaw = localStorage.getItem(DRAW_EXCEL_SAVED_IDS_KEY);
    const localIds: string[] = localRaw ? JSON.parse(localRaw) : [];
    if (localIds.includes(String(drawId))) return null;
  } catch (_) {}
  const state = getState?.();
  let rows: any[] = state?.drawRequestStore?.excelData ?? [];
  if (!rows?.length) {
    try {
      const stored = sessionStorage.getItem("drawExcelUpload");
      if (stored) rows = JSON.parse(stored);
    } catch (_) {}
  }
  if (!rows?.length) return null;
  return rows.find(
    (row: any) => String(row?.drawId) === String(drawId)
  ) ?? null;
}

function mergeExcelRowIntoDrawResponse(
  response: any,
  excelRow: any,
  drawId: string
): void {
  if (!excelRow || !response) return;
  // Never overwrite when API already has saved amount or bank (e.g. after save and refresh).
  const apiHasAmount =
    response.drawAmountDetails?.drawAmount != null &&
    String(response.drawAmountDetails.drawAmount).trim() !== "" &&
    Number(response.drawAmountDetails.drawAmount) !== 0;
  const apiHasBank =
    response.bankDetails != null &&
    (Array.isArray(response.bankDetails)
      ? response.bankDetails.length > 0 &&
        (response.bankDetails[0]?.accountNumber ?? response.bankDetails[0]?.routing)
      : (response.bankDetails?.accountNumber ?? response.bankDetails?.routing));
  if (apiHasAmount || apiHasBank) return;

  const emptyAmount =
    !response.drawAmountDetails?.drawAmount ||
    String(response.drawAmountDetails.drawAmount).trim() === "" ||
    Number(response.drawAmountDetails.drawAmount) === 0;
  // Support multiple possible keys from Excel/upload API (drawAmount, drawAmountDetails.drawAmount, requestedAmount, amount)
  const excelAmount =
    excelRow.drawAmountDetails?.drawAmount ??
    excelRow.drawAmount ??
    excelRow.requestedAmount ??
    excelRow.amount;
  if (emptyAmount && (excelAmount !== undefined && excelAmount !== null && String(excelAmount).trim() !== "")) {
    response.drawAmountDetails = response.drawAmountDetails ?? {};
    const src = excelRow.drawAmountDetails ?? excelRow;
    response.drawAmountDetails.drawAmount =
      src.drawAmount ??
      excelRow.drawAmount ??
      excelRow.requestedAmount ??
      excelRow.amount ??
      response.drawAmountDetails.drawAmount;
    response.drawAmountDetails.wireFee = src.wireFee ?? response.drawAmountDetails.wireFee ?? "0.00";
    response.drawAmountDetails.costOfInspection = src.costOfInspection ?? response.drawAmountDetails.costOfInspection ?? "0.00";
    response.drawAmountDetails.titleServiceFee = src.titleServiceFee ?? response.drawAmountDetails.titleServiceFee ?? "0.00";
    response.drawAmountDetails.wireReturnFee = src.wireReturnFee ?? response.drawAmountDetails.wireReturnFee ?? "0.00";
    if (response.stage === DrawStage.draft && response.drawAmountDetails) {
      response.drawAmountDetails.netFundsToBorrower = calculateNetAmount(
        response.drawAmountDetails
      );
    }
  }

  const hasResponseBank =
    response.bankDetails &&
    (Array.isArray(response.bankDetails)
      ? response.bankDetails.length > 0 &&
        (response.bankDetails[0]?.accountNumber ?? response.bankDetails[0]?.routing)
      : (response.bankDetails?.accountNumber ?? response.bankDetails?.routing));
  const bankFromExcel =
    excelRow.bankDetails &&
    (Array.isArray(excelRow.bankDetails)
      ? excelRow.bankDetails[0]
      : excelRow.bankDetails);
  const hasExcelBank =
    bankFromExcel?.accountNumber ?? bankFromExcel?.routing ?? excelRow.accountNumber ?? excelRow.routing;
  // Only use Excel bank when API has no saved bank (e.g. first load after Excel create). After user saves and reloads, prefer API.
  if (hasExcelBank && !hasResponseBank) {
    const b = bankFromExcel ?? excelRow;
    response.bankDetails = {
      accountNumber: b.accountNumber ?? excelRow.accountNumber ?? 0,
      routing: b.routing ?? excelRow.routing ?? "",
      bankName: b.bankName ?? excelRow.bankName ?? "",
      accountName: b.accountName ?? excelRow.accountName ?? "",
      bankDetailId: b.bankDetailId ?? 0
    };
  }
}

const updateDrawDetailsRedux =
  (response: any, isInspection?: boolean, drawId?: string) => async (dispatch: any) => {
    dispatch(showLoader());
    dispatch(updateDrawObj(response));
    let bankPayload =
      response.bankDetails == null
        ? initBankObj
        : Array.isArray(response.bankDetails)
          ? response.bankDetails.length > 0
            ? (pickDefaultBank(response.bankDetails) || response.bankDetails[0])
            : initBankObj
          : response.bankDetails;
    // After refresh, restore saved bank so we don't show list[0] when user had selected a different bank
    if (drawId) {
      try {
        const stored = sessionStorage.getItem(`${DRAW_SAVED_BANK_KEY_PREFIX}${drawId}`);
        if (stored) {
          const savedBank = JSON.parse(stored);
          const hasSaved = (savedBank.accountNumber != null && savedBank.accountNumber !== "" && savedBank.accountNumber !== 0) ||
            (savedBank.routing != null && String(savedBank.routing).trim() !== "");
          if (hasSaved) {
            const list = Array.isArray(response.bankDetails) ? response.bankDetails : response.bankDetails ? [response.bankDetails] : [];
            const match = list.find(
              (b: any) =>
                String(b?.accountNumber ?? "") === String(savedBank?.accountNumber ?? "") &&
                String(b?.routing ?? "") === String(savedBank?.routing ?? "")
            );
            bankPayload = match ?? savedBank;
          }
        }
      } catch (_) {}
    }
    dispatch(updateSelectedBankObj(bankPayload));
    if (response?.propertyDetails?.length) {
      dispatch(updateDrawPropOptions(response.propertyDetails));
    }

    // Check condition and dispatch action to update final approval
    if (response.finalApprovalNotRequired) {
      dispatch(
        updateFinalApproval(response.finalApprovalNotRequired.toLowerCase())
      );
    }
    let filDocsList = response.drawDocuments;
    if (isInspection) {
      filDocsList = response.drawDocuments?.filter(
        (item: any) =>
          item.isPurchasePrimary &&
          item.tags.some((tag: any) => tag.tag.code === "DDDC")
      );
    }
    dispatch(getDocsByDrawId(filDocsList));
    // const discussions =
    //   Object.keys(response?.drawDiscussions)?.length ||
    //   Array.isArray(response?.drawDiscussions)
    //     ? response?.drawDiscussions
    //     : [];
    // const drawDiscussionsRev = [...discussions]?.reverse();
    dispatch(updateDrawDiscussions(response.drawDiscussions));
    dispatch(hideLoader());
  };

export function getDrawDetailsByDrawId(
  drawId: string,
  isOrig: boolean,
  isInspection?: boolean,
  updateNetFund?: boolean
): any {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(showLoader());
      const owner = getCookie("org_id");
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}?owner=${owner}&isOriginator=${isOrig}`;
      const response = (await publicClient.get(url)).data;
      if (
        response.stage === DrawStage.draft &&
        response.drawAmountDetails &&
        updateNetFund
      ) {
        response.drawAmountDetails.netFundsToBorrower = calculateNetAmount(
          response?.drawAmountDetails
        );
      }
      if (response) {
        response.drawId = response.drawId ?? drawId;
        // Prevent a race on first land (Excel create): v2 loan-details may auto-select a single property,
        // then this draw-details response (often with empty/missing propertyDetails) arrives and overwrites it.
        const existingProp = getState?.()?.drawRequestStore?.drawDetails?.propertyDetails;
        if (existingProp?.length && !response?.propertyDetails?.length) {
          response.propertyDetails = existingProp;
        }

        // Skip Excel merge only when API already has amount/bank (saved data). For new draws API returns 0/empty, so we merge Excel.
        const draw = response.payload?.drawDetails ?? response.payload ?? response.drawDetails ?? response;
        const amountDetails = draw.drawAmountDetails ?? {};
        const bankDetails = draw.bankDetails;
        const apiHasAmount =
          amountDetails.drawAmount != null &&
          String(amountDetails.drawAmount).trim() !== "" &&
          Number(amountDetails.drawAmount) !== 0;
        const apiHasBank =
          bankDetails != null &&
          (Array.isArray(bankDetails)
            ? bankDetails.length > 0 &&
              (bankDetails[0]?.accountNumber ?? bankDetails[0]?.routing)
            : (bankDetails?.accountNumber ?? bankDetails?.routing));
        const skipExcelMerge = apiHasAmount || apiHasBank;

        if (!skipExcelMerge) {
          const excelRow = getExcelRowForDraw(drawId, getState);
          if (excelRow) {
            mergeExcelRowIntoDrawResponse(response, excelRow, drawId);
            // Ensure nested draw object also has merged amount when API returns nested structure (e.g. response.drawDetails)
            if (draw !== response && response.drawAmountDetails && typeof draw === "object") {
              draw.drawAmountDetails = { ...(draw.drawAmountDetails ?? {}), ...response.drawAmountDetails };
            }
            const hasResponseBank =
              response.bankDetails &&
              (Array.isArray(response.bankDetails)
                ? response.bankDetails.length > 0 &&
                  (response.bankDetails[0]?.accountNumber ?? response.bankDetails[0]?.routing)
                : (response.bankDetails?.accountNumber ?? response.bankDetails?.routing));
            const hasExcelBank = !!(excelRow.bankDetails || excelRow.accountNumber || excelRow.routing);
            if (hasExcelBank && !hasResponseBank) {
              const b = (excelRow.bankDetails && (Array.isArray(excelRow.bankDetails) ? excelRow.bankDetails[0] : excelRow.bankDetails)) ?? excelRow;
              const bank = {
                accountNumber: b.accountNumber ?? excelRow.accountNumber ?? 0,
                routing: b.routing ?? excelRow.routing ?? "",
                bankName: b.bankName ?? excelRow.bankName ?? "",
                accountName: b.accountName ?? excelRow.accountName ?? "",
                bankDetailId: b.bankDetailId ?? 0
              };
              response.bankDetails = bank;
              try {
                sessionStorage.setItem(`drawExcelBank_${drawId}`, JSON.stringify(bank));
              } catch (_) {}
            }
          }
        }

        dispatch(updateDrawDetailsRedux(response, isInspection, drawId));
        let docList = response.drawDocuments;
        if (docList && docList?.length > 0) {
          let isPrimaryAPITriggered = false;
          let primaryDocId: any;
          let inspectionDocPrimary = false;
          docList.forEach((item: any) => {
            const tagsArr = item?.tags;
            const tagCode = tagsArr?.[0]?.tag?.code;
            const confidenceScore = tagsArr?.[0]?.confidence_score;
            if (
              tagCode === "DDDC" &&
              item.isPurchasePrimary === false &&
              item?.assets?.length > 0 &&
              confidenceScore > 0.9
            ) {
              isPrimaryAPITriggered = true;
              primaryDocId = item.documentId;
            } else if (tagCode === "DDDC" && item.isPurchasePrimary === true) {
              inspectionDocPrimary = true;
            }
          });
          if (isPrimaryAPITriggered && !inspectionDocPrimary) {
            try {
              const payload = {
                id: primaryDocId,
                isPurchasePrimary: true
              };
              updatePurchaseFlags([payload]);
              docList = docList?.map((item: any) => {
                if (item.documentId === primaryDocId) {
                  item.isPurchasePrimary = true;
                }
                return item;
              });
            } catch (err) {
              console.error(err);
            }
          }
        }
        dispatch(hideLoader());
      }
    } catch (err) {
      console.error(err);
      dispatch(hideLoader());
    }
  };
}
export const getDrawHistory = (toorakLoanId: string): any => {
  const isOrig: boolean = isOrigUser();
  if (isOrig) return;
  return async (dispatch: any) => {
    // clearning previous data; AM-276
    dispatch(updateDrawHistory([]));
    const owner = getCookie("org_id");
    const url = `${apiUrlHost}/drawservice/assetmanagement/v2/draws/${toorakLoanId}/draw-history?owner=${owner}&isOriginator=${isOrig}`;

    try {
      // Fetch data
      const resp = await publicClient.get(url);

      // Dispatch action to update draw history with fetched data
      dispatch(updateDrawHistory(resp.data));
    } catch (error) {
      // Handle error, if needed
      console.error("Error fetching draw history:", error);
    }
  };
};

export function updateIsFinalApprovalRequired(
  flag: string,
  drawId: string,
  isOrig: boolean
): any {
  return async (dispatch: any) => {
    const owner = getCookie("org_id");
    dispatch(showLoader());
    if (flag === "yes") {
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/setFinalApprovalNotRequired?owner=${owner}&isOriginator=${isOrig}`;
      // eslint-disable-next-line
      const response = await publicClient.get(url);
      dispatch(hideLoader());
    } else {
      const url = `${apiUrlHost}/drawservice/assetmanagement/draws/${drawId}/unsetFinalApprovalNotRequired?owner=${owner}&isOriginator=${isOrig}`;
      // eslint-disable-next-line
      const response = await publicClient.get(url);
      dispatch(hideLoader());
    }
    dispatch(updateFinalApproval(flag));
  };
}

export function createDrawFromExcel(cloudFilePathBucket: any): Promise<any> {
  const username = getUsername();
  const isOriginator = isOrigUser();
  const requestBody: any = {
    owner: getCookie("org_id"),
    isTestParty: getCookie("isTestParty"),
    isOriginator,
    cloudFilePath: {
      BucketName: cloudFilePathBucket.cloudFilePathBucket.BucketName,
      Bucketkey: cloudFilePathBucket.cloudFilePathBucket.Bucketkey
    },
    username
  };
  const url = `${getConfig().apiUrl}/aggregate/extractdraw/BulkDrawUpload`;
  return new Promise((resolve, reject) => {
    publicClient
      .post(url, requestBody)
      .then((res: any) => resolve(res))
      .catch(reject);
  });
}

export function getFilterOption(key: string) {
  const owner = getCookie("org_id");
  const isOriginator = isOrigUser();
  const url = `${
    getConfig().apiUrl
  }/drawservice/assetmanagement/draws/getValuesForColumn/${key}?owner=${owner}&isOriginator=${isOriginator}&isTestParty=${getCookie(
    "isTestParty"
  )}`;
  return publicClient.get(url);
}

export function deleteBankDetailsById(
  bankDetailId: number,
  drawObj: DrawObj
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const { borrowerEntityName, originatorId, primaryLoanId } = drawObj;
      const owner = getCookie("org_id");
      const isOriginator = isOrigUser();
      const url = `${apiUrlHost}/drawservice/assetmanagement/bankdetails/${bankDetailId}?owner=${owner}&isOriginator=${isOriginator}`;
      const response: any = bankDetailId
        ? await publicClient.delete(url, {
            data: { borrowerEntityName, originatorId, loanId: primaryLoanId }
          })
        : [];
      dispatch(updateBankList(response.data));
      // if (response?.data?.bankList?.length)
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}